// --- Scroll lock helpers (works on iOS/Android/Desktop) ---
let __scrollY = 0;
function lockPageScroll() {
  __scrollY = window.scrollY || document.documentElement.scrollTop || 0;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  document.body.style.position = 'fixed';
  document.body.style.top = `-${__scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
  if (scrollbarWidth > 0) {
    // Prevent layout shift when the scrollbar disappears
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function unlockPageScroll() {
  const y = Math.abs(parseInt(document.body.style.top || '0', 10)) || __scrollY || 0;

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';

  window.scrollTo(0, y);
}

// --- Your existing code (with small edits) ---
const loginBtn = document.querySelectorAll(".SSO_popup_login");  // simple login
const registerBtn = document.querySelectorAll(".SSO_popup_register");  // cc register
const eliteJoinBtn = document.querySelectorAll(".SSO_popup_elite_join"); // elite register
const eliteUpgradeBtn = document.querySelectorAll(".SSO_popup_elite_upgrade"); // cc to elite member

const popup = document.getElementById('new_popup-modal2');
const close_popup = document.querySelector('#new_popup-modal2 .close_popup');
const overlay = document.getElementById('new_popup-overlay2');

const mainLoginForm = document.querySelector('.main_login_form');
const mainSignupForm = document.querySelector('.main_signup_form');
const mainSignupEliteForm = document.querySelector('.main_elite_signup_form');
const mainEliteUpgradeForm = document.querySelector('.main_elite_upgrade_form');
const renewMembershipPopup = document.querySelector('.subscribe_elite_membershop');
const campaignRenewMembershipPopup = document.querySelector('.campaign_elite_membership');

if (!localStorage.getItem('popupClosed') && !window.isCustomerLoggedIn) { 
  setTimeout(() => { 
    if (localStorage.getItem('popupClosed') !== 'true') {
      openPopup2('signup_form');
    } 
  }, 3000);
}

const closePopup2 = function (firstTime = false) {
  popup.style.display = 'none';
  overlay.style.display = 'none';
  unlockPageScroll(); // <-- unlock when closing

  if (firstTime) localStorage.setItem('popupClosed', 'true');
};

function openPopup2(form) {
  document.querySelectorAll('.new_forms').forEach(f => f.classList.add('new_hidden'));
  if (form === 'login_form') {
    mainLoginForm.classList.remove('new_hidden');
  } else if (form === 'signup_form') {
    mainSignupForm.classList.remove('new_hidden');
  } else if (form === 'signup_elite_form') {
    mainSignupEliteForm.classList.remove('new_hidden');
  } else if (form === 'signup_upgrade_form') {
    mainEliteUpgradeForm.classList.remove('new_hidden');
  }

  popup.style.display = 'block';
  overlay.style.display = 'block';
  lockPageScroll(); // <-- lock when opening
};

openResubscribeMembership = function () {
  const renew_popup_opened = localStorage.getItem("renew_popup_open_once");
  console.log(renew_popup_opened);
  if(!renew_popup_opened) {
    const days_expires = localStorage.getItem("membership_expiring_in_days");
    renewMembershipPopup.querySelector(".expires_days").textContent = days_expires;
    mainLoginForm.classList.add('new_hidden');
    renewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    localStorage.setItem("renew_popup_open_once", true)
    lockPageScroll();
  }
}
checkIfMembershipExpiring = function(date) {
const expiryDate = new Date(date);

localStorage.setItem("membership_expiry_date", expiryDate.toISOString());

const savedExpiry = localStorage.getItem("membership_expiry_date");

  if (savedExpiry) {
    const expiry = new Date(savedExpiry);
    const today = new Date();
    
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const membershipExpiringSoon = diffDays <= 30;

    localStorage.setItem("membership_expiring_soon", membershipExpiringSoon);
    localStorage.setItem("membership_expiring_in_days", diffDays);

    // console.log(`Membership expires in ${diffDays} days`);
    // console.log("Expiring soon:", membershipExpiringSoon);
  }
}

// close on overlay / X
overlay.addEventListener('click', function () {
  if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') !== 'true') {
    closePopup2(true);
  } else {
    closePopup2();
  }
});
close_popup.addEventListener('click', function () {
  if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') !== 'true') { 
    closePopup2(true);
  } else {
    closePopup2();
  }
});

// Optional: close on ESC
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && overlay.style.display === 'block') closePopup2();
});

// --- Normalize triggers: prevent default jump + avoid form submission ---
function bindTrigger(nodeList, formName) {
  nodeList.forEach((btn) => {
    // If it's a <button> inside a form, make sure it's not submitting
    if (btn.tagName === 'BUTTON' && btn.type !== 'button') btn.type = 'button';

    btn.addEventListener('click', (e) => {
      // Cancel anchor navigation or form submit that causes page jump
      if (e) { e.preventDefault(); e.stopPropagation(); }
      openPopup2(formName);
    });
  });
}

bindTrigger(loginBtn, 'login_form');
bindTrigger(registerBtn, 'signup_form');
bindTrigger(eliteJoinBtn, 'signup_elite_form');
bindTrigger(eliteUpgradeBtn, 'signup_upgrade_form');

async function handleMembershipRenewal() {
  const urlParams = new URLSearchParams(window.location.search);
  const isMembershipRenew = urlParams.get('membership_renew') === 'true';

  if (isMembershipRenew && !window.isCustomerLoggedIn) {
    campaignRenewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    mainLoginForm.classList.add('new_hidden');
  }
  if (isMembershipRenew && window.isCustomerLoggedIn) {
    renewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    mainLoginForm.classList.add('new_hidden');
  }

  const isMembershipRenewDirect = urlParams.get('membership_renew_direct') === 'true';

  if (isMembershipRenewDirect) {
    try {
      await addEliteProductToCart();
      window.location.href = "/checkout";
    } catch (error) {
      console.error('Error:', error);
    }
  }
}
if(window.enableRenew) { 
  handleMembershipRenewal();
}

document.addEventListener('DOMContentLoaded', function () {
  const campaignRenewBtn = document.querySelector('.login_to_renew');
  
  if (campaignRenewBtn) {
    campaignRenewBtn.addEventListener('click', function () {
      campaignRenewMembershipPopup?.classList.add('new_hidden');
      mainLoginForm?.classList.remove('new_hidden');
      popup.style.display = 'block';
      overlay.style.display = 'block';
    });
  }
});

